import { render, staticRenderFns } from "./VTransport.vue?vue&type=template&id=000d6112&"
import script from "./VTransport.vue?vue&type=script&lang=js&"
export * from "./VTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports